import { initialListPaginationMeta } from "utils/helpers/pagination";

import {
  HydraulicManufacturerForm,
  HydraulicManufacturerState,
} from "../types";

export const initialForm: HydraulicManufacturerForm = {
  code: "",
  description: "",
};

export const initialHydraulicManufacturerMeta = initialListPaginationMeta;

export const initialState: HydraulicManufacturerState = {
  loading: false,
  saving: false,
  list: [],
  page: 1,
  perPage: 20,
  meta: initialHydraulicManufacturerMeta,
  error: null,
  isAddModalOpen: false,
  form: initialForm,
};
